import { useState, useRef, useEffect } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

const useRecaptcha = () => {
  const [capchaToken, setCapchaToken] = useState<string>('');
  const recaptchaRef = useRef<ReCAPTCHA | null>(null);

  // Handle recaptcha token change
  const handleRecaptcha = (token: string | null) => {
    setCapchaToken(token || '');
  };

  // Automatically reset the captcha after a timeout when a token is received
  useEffect(() => {
    if (capchaToken) {
      const timeout = setTimeout(() => {
        if (recaptchaRef.current) {
          recaptchaRef.current.reset();
        }
        setCapchaToken('');
      }, 110000); // Reset after 110 seconds

      return () => clearTimeout(timeout); // Cleanup the timeout on component unmount or token change
    }
  }, [capchaToken]);

  return { capchaToken, recaptchaRef, handleRecaptcha };
};

export default useRecaptcha;
